import { breakpointBiggerThan, getBreakpoint } from "../../../js/breakpoints.js";
import { LightBox } from "../../../modules/lightbox/LightBox.js";
import { createSvgiconString } from "../../svgicons/front.js";


const dom = {
    PLAYER_CONTAINER:          $slider => $slider.querySelector(".PLAYER_CONTAINER"),
    PLAYER_CONTAINER_CHILDREN: $slider => [...$slider.querySelectorAll(".PLAYER_CONTAINER > *")],
    btns: $slider => [...$slider.querySelectorAll("button")]
};


/**
 * Slider simple.
 * Permet de visualiser une ou plusieurs images en même temps.
 * Basé sur le css des slides : chacune doit contenir flex: 0 0 <imgWidth>%; 
 * Où imgWidth représente la largeur occupée par l'image dans la view.
 * Exemple : 0 0 100% => une seule image visible en même temps (elle représente 100% de l'espace de la view)
 * Exemple : 0 0 33%  => 3 images visibles en même temps
 */
export class SliderSimple {
    id;
    duration;  
    useLightbox;      
    element     = null;
    timer       = null;
    current     = 0;
    // obtenus avec updateSizes() :
    nb          = 0;
    gap         = 0;
    nbImgByView = 1;// nb d'images vues en même temps (déterminé en css par flex:0 0 <x>%)

    /**
     * @param {Element} $element
     * @param {number?} duration
     */
    constructor($element, {id, useLightbox=false, duration=5000}) {
        this.element     = $element;
        this.id          = id;
        this.useLightbox = useLightbox;
        this.duration    = duration;
        this.direction   = false;
        this.updateSizes();
        this.update();

        //------------------------- events ---------------------------------

        const prevBtn = $element.querySelector(".PREV");
        const nextBtn = $element.querySelector(".NEXT");
        prevBtn.classList.add("hide");

        nextBtn.addEventListener("click", e => {
            if(this.current < this.getDom("PLAYER_CONTAINER_CHILDREN").length - 1){
                this.current++;
                let end = this.nb - this.nbImgByView;
                if(end < 1) end = 1;
                if(this.current === end)
                    nextBtn.classList.add("hide");
                prevBtn.classList.remove("hide");
                this.update();
            }
        });
        prevBtn.addEventListener("click", e => {
            if(this.current > 0){
                this.current--;
                if(this.current === 0)
                    prevBtn.classList.add("hide"); 
                nextBtn.classList.remove("hide");               
                this.update();
            }
        });

        window.addEventListener("resize", e => {
            this.updateSizes();
            this.update();
        });
    }
    /**
     * 
     */
    update(){
        const $slides    = this.getDom("PLAYER_CONTAINER_CHILDREN");
        const slide      = $slides[this.current];
        const slideWidth = slide.clientWidth;
        const offset     = this.current * (slideWidth + this.gap);
        this.getDom("PLAYER_CONTAINER").style.transform = `translateX(-${offset}px)`;
    }

    /**
     * Update membres :
     * - nb
     * - gap
     * - nbImgByView
     */
    updateSizes(){
        const $container = this.getDom("PLAYER_CONTAINER");
        const $slides    = this.getDom("PLAYER_CONTAINER_CHILDREN");
        // this.nb
        this.nb = $slides.length;
        if($container instanceof Element && this.nb > 0){
            // this.gap
            let {gap} = getComputedStyle($container);
            gap = (gap === "normal") ? 0 : +gap.replace("px", "");         
            if(!isNaN(gap))
                this.gap = gap;
            else console.warn("SliderSimple.prototype.updateSizes() : problème de gap (reste à 0 par défaut)")
            // this.nbImgByView
            let {flex} = getComputedStyle($slides[0]);
            flex = +flex.replace("0 0 ", "").replace("%","");
            if(!isNaN(flex))
                this.nbImgByView = Math.round(100/flex);
        } else console.warn("SliderSimple.prototype.updateSizes() : aucune slide") 
    }

    // --------------------------- Accès DOM -------------------------------------

    /**
     * Renvoi le dom de funcname
     * @param {string} funcname :
     * @returns {Element|Element[]|FALSE}
     */
    getDom(funcname) {
        return dom[funcname](this.element);
    }
}
